<script>
    import {onMount} from "svelte";


    import Tab, {Label} from '@smui/tab';
    import TabBar from '@smui/tab-bar';

    import MyTab from "./Tab.svelte";

    import {globalState} from "../store/store";

    export let privateVersion;
    /** @type {(bool|array)} Résultats de l'appel au simulateur */
    export let results = false;
    /** @type {bool} La fenêtre doit-elle s'ouvrir ? */
    export let openResultDialog = false;
    /** @type {array} entêtes de colonne */
    export let columnHeaders;
    /** @type {array} entêtes de ligne */
    export let lineHeaders;

    let active = 'Avec Mutuelle et Sans CP';
    const columnTab = [
        'Avec Mutuelle et Sans CP',
        'Avec Mutuelle et Avec CP',
        'Sans Mutuelle et Sans CP',
        'Sans Mutuelle et Avec CP',
    ];

    let activeTab = $globalState.l;

    if ('b' === activeTab) {
        active = 'Avec Mutuelle et Avec CP';
    } else if ('c' === activeTab) {
        active = 'Sans Mutuelle et Sans CP';
    } else if ('d' === activeTab) {
        active = 'Sans Mutuelle et Avec CP';
    }


    $: hovers = [];

    onMount(() => {
        lineHeaders.forEach((line, indexLine, lines) => {
            hovers[indexLine] = [];
            columnHeaders.forEach((col, indexCol, cols) => {
                hovers[indexLine][indexCol] = col === indexCol ? true : false;
            });
        });
    });

    function closeHandler() {
        openResultDialog = false;
    }

    function getValue(result, key, period = "monthly") {
        let value = 0;

        let element = lineHeaders.find((element) => element.key === key);

        let periodFactor = 1;
        if (period === "yearly" && key !== "dailyRate") {
            periodFactor = 12;
        }

        value = result[element.key];
        return value * periodFactor;
    }

    function setHighlightClassHandler(event) {
        let col = event.target.getAttribute("col");
        let line = event.target.getAttribute("line");

        lineHeaders.forEach((line, indexLine, lines) => {
            columnHeaders.forEach((col, indexCol, cols) => {
                hovers[indexLine][indexCol] = col === indexCol ? true : false;
            });
        });
    }

    function removeHighlightClassHandler(event) {
        return setHighlightClassHandler(event);
    }

    function getHover(indexLine, indexCol) {
        return hovers[indexLine][indexCol];
    }
</script>

<!--
     @component
     Affiche le résultat du simulateur
-->
{#if results}
    <div>
        <TabBar tabs={columnTab} let:tab bind:active class="resume-salary">
            <!-- Note: the `tab` property is required! -->
            <Tab {tab}>
                <Label>{tab}</Label>
            </Tab>
        </TabBar>

        {#if active === 'Sans Mutuelle et Sans CP'}
            {#each results as result, col}
                {#if col === 2}
                    <MyTab bind:result {privateVersion} check="c"/>
                {/if}
            {/each}
        {:else if active === 'Sans Mutuelle et Avec CP'}
            {#each results as result, col}
                {#if col === 3}
                    <MyTab bind:result {privateVersion} check="d"/>
                {/if}
            {/each}
        {:else if active === 'Avec Mutuelle et Sans CP'}
            {#each results as result, col}
                {#if col === 0}
                    <MyTab bind:result {privateVersion} check="a"/>
                {/if}
            {/each}
        {:else if active === 'Avec Mutuelle et Avec CP'}
            {#each results as result, col}
                {#if col === 1}
                    <MyTab bind:result {privateVersion} check="b"/>
                {/if}
            {/each}
        {/if}

        <!--
        <div style="margin-top: 1em;">
            <div>Programmatically select:</div>
            {#each columnTab as tab}
                <Button on:click={() => (active = tab)}><Label>{tab}</Label></Button>
            {/each}
        </div>
        -->
    </div>
{/if}
